/* KIAT. — small behaviours for the brand sections. No dependencies.
   Every module looks for data-k-* hooks, so sections stay plain HTML. */
(function () {
  'use strict';

  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---- Clock in Thailand time (Asia/Bangkok zone): <span data-k-clock></span> ---- */
  function clock() {
    var els = $$('[data-k-clock]');
    if (!els.length) return;
    var fmt;
    try { fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Bangkok', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }); } catch (e) { fmt = null; }
    var tick = function () {
      var t = fmt ? fmt.format(new Date()) : '--:--:--';
      els.forEach(function (el) { el.textContent = t; });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Accordion: button[data-k-acc] + next .k-panel ---- */
  function accordion(root) {
    $$('[data-k-acc]', root).forEach(function (btn) {
      if (btn.__k) return; btn.__k = true;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.classList.toggle('is-open', !open);
      });
    });
  }

  /* ---- Language switch: [data-k-lang-btn="en"] / [data-k-lang-panel="en"] inside [data-k-lang] ---- */
  function lang(root) {
    $$('[data-k-lang]', root).forEach(function (wrap) {
      if (wrap.__k) return; wrap.__k = true;
      var btns = $$('[data-k-lang-btn]', wrap);
      var set = function (code) {
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-k-lang-btn') === code ? 'true' : 'false'); });
        $$('[data-k-lang-panel]', wrap).forEach(function (p) { p.hidden = p.getAttribute('data-k-lang-panel') !== code; });
      };
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-k-lang-btn')); }); });
    });
  }

  /* ---- Archive filter: [data-k-archive] with chips [data-k-filter="line|status"][data-value]
         rows [data-k-item][data-line][data-status], groups [data-k-group], count [data-k-count] ---- */
  function archive(root) {
    $$('[data-k-archive]', root).forEach(function (wrap) {
      if (wrap.__k) return; wrap.__k = true;
      var state = { line: 'All', status: 'All' };
      var apply = function () {
        var n = 0;
        $$('[data-k-item]', wrap).forEach(function (it) {
          var ok = (state.line === 'All' || it.getAttribute('data-line') === state.line) &&
                   (state.status === 'All' || it.getAttribute('data-status') === state.status.toLowerCase());
          it.hidden = !ok; if (ok) n++;
        });
        $$('[data-k-group]', wrap).forEach(function (g) { g.hidden = !$$('[data-k-item]:not([hidden])', g).length; });
        $$('[data-k-count]', wrap).forEach(function (c) { c.textContent = n + (n === 1 ? ' piece' : ' pieces'); });
        $$('[data-k-empty]', wrap).forEach(function (e) { e.hidden = n !== 0; });
        $$('[data-k-filter]', wrap).forEach(function (c) {
          c.setAttribute('aria-pressed', state[c.getAttribute('data-k-filter')] === c.getAttribute('data-value') ? 'true' : 'false');
        });
      };
      $$('[data-k-filter]', wrap).forEach(function (c) {
        c.addEventListener('click', function () { state[c.getAttribute('data-k-filter')] = c.getAttribute('data-value'); apply(); });
      });
      apply();
    });
  }

  /* ---- Countdown: [data-k-countdown][data-target="2026-11-23T12:27:00+07:00"]
         units [data-k-unit="d|h|m|s"], states [data-k-cd-wait] / [data-k-cd-open] ---- */
  function countdown(root) {
    $$('[data-k-countdown]', root).forEach(function (wrap) {
      if (wrap.__k) return; wrap.__k = true;
      var target = Date.parse(wrap.getAttribute('data-target'));
      if (isNaN(target)) return;
      var forceOpen = wrap.getAttribute('data-force-open') === 'true';
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var left = isNaN(target) ? 0 : Math.max(0, target - Date.now());
        var open = forceOpen || left === 0;
        var s = Math.floor(left / 1000);
        var vals = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        $$('[data-k-unit]', wrap).forEach(function (u) {
          var v = pad(vals[u.getAttribute('data-k-unit')]);
          if (u.textContent === v) return;
          u.textContent = v;
          u.classList.remove('is-tick'); void u.offsetWidth; u.classList.add('is-tick');
        });
        wrap.classList.toggle('is-open', open);
        $$('[data-k-cd-wait]', wrap).forEach(function (e) { e.hidden = open; });
        $$('[data-k-cd-open]', wrap).forEach(function (e) { e.hidden = !open; });
        return open;
      };
      if (!tick()) { var t = setInterval(function () { if (tick()) clearInterval(t); }, 1000); }
    });
  }

  /* ---- Buy bar (phones): [data-kpr-bar][data-kpr-for="formId"] shows while that form's button is off screen ---- */
  function buyBar(root) {
    $$('[data-kpr-bar]', root).forEach(function (bar) {
      if (bar.__k) return; bar.__k = true;
      var form = document.getElementById(bar.getAttribute('data-kpr-for'));
      var btn = form && form.querySelector('[type="submit"]');
      if (!btn || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-shown', !entries[entries.length - 1].isIntersecting);
      }).observe(btn);
    });
  }

  /* ---- Countdown stage (.kcd): shorter arrival on a repeat visit, light that trails the pointer ---- */
  function countdownStage(root) {
    $$('.kcd', root).forEach(function (wrap) {
      if (wrap.__kStage) return; wrap.__kStage = true;
      try {
        if (sessionStorage.getItem('k-cd-seen')) wrap.classList.add('is-quick');
        sessionStorage.setItem('k-cd-seen', '1');
      } catch (e) {}

      if (!window.matchMedia || !matchMedia('(pointer: fine)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var light = document.createElement('div');
      light.className = 'kcd-light';
      light.setAttribute('aria-hidden', 'true');
      wrap.insertBefore(light, wrap.firstChild);
      var tx = 0, ty = 0, x = 0, y = 0, raf = 0, started = false;
      var step = function () {
        x += (tx - x) * 0.08; y += (ty - y) * 0.08;
        light.style.setProperty('--kx', x + 'px');
        light.style.setProperty('--ky', y + 'px');
        raf = Math.abs(tx - x) + Math.abs(ty - y) > 0.5 ? requestAnimationFrame(step) : 0;
      };
      wrap.addEventListener('pointermove', function (e) {
        var r = wrap.getBoundingClientRect();
        tx = e.clientX - r.left; ty = e.clientY - r.top;
        if (!started) { x = tx; y = ty; started = true; }
        wrap.classList.add('is-lit');
        if (!raf) raf = requestAnimationFrame(step);
      });
      wrap.addEventListener('pointerleave', function () { wrap.classList.remove('is-lit'); });
    });
  }

  /* ---- Quiz: [data-k-quiz] containing <script type="application/json" data-k-quiz-data>
         { "questions":[{ "q":"", "a":[{ "t":"", "w":{ "MORPHE":2 } }] }],
           "order":["MORPHE",...], "results":{ "MORPHE":{ "label":"", "text":"", "cta":"", "href":"" } } } ---- */
  function quiz(root) {
    $$('[data-k-quiz]', root).forEach(function (wrap) {
      if (wrap.__k) return; wrap.__k = true;
      var dataEl = wrap.querySelector('[data-k-quiz-data]');
      if (!dataEl) return;
      var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var q = function (s) { return wrap.querySelector(s); };
      var asking = q('[data-k-quiz-ask]'), done = q('[data-k-quiz-done]');
      var picks = [];
      var render = function () {
        var step = picks.length, total = data.questions.length;
        if (step < total) {
          asking.hidden = false; done.hidden = true;
          var item = data.questions[step];
          q('[data-k-quiz-progress]').textContent = (step + 1 < 10 ? '0' : '') + (step + 1) + ' / ' + (total < 10 ? '0' : '') + total;
          q('[data-k-quiz-bar]').style.width = Math.round(((step + 1) / total) * 100) + '%';
          q('[data-k-quiz-q]').textContent = item.q;
          var list = q('[data-k-quiz-answers]'); list.innerHTML = '';
          item.a.forEach(function (ans, i) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'k-ans';
            b.innerHTML = '<span class="k-mono" aria-hidden="true">→</span>';
            b.appendChild(document.createTextNode(ans.t));
            b.addEventListener('click', function () { picks.push(i); render(); });
            list.appendChild(b);
          });
          q('[data-k-quiz-back]').hidden = step === 0;
        } else {
          asking.hidden = true; done.hidden = false;
          var score = {}; data.order.forEach(function (k) { score[k] = 0; });
          picks.forEach(function (ai, qi) { var w = data.questions[qi].a[ai].w; Object.keys(w).forEach(function (k) { score[k] += w[k]; }); });
          var best = data.order[0];
          data.order.forEach(function (k) { if (score[k] > score[best]) best = k; });
          var r = data.results[best] || {};
          q('[data-k-quiz-name]').textContent = best;
          q('[data-k-quiz-label]').textContent = r.label || '';
          q('[data-k-quiz-text]').textContent = r.text || '';
          var cta = q('[data-k-quiz-cta]'); cta.textContent = r.cta || 'Continue'; cta.setAttribute('href', r.href || '/');
        }
      };
      q('[data-k-quiz-back]').addEventListener('click', function () { picks.pop(); render(); });
      q('[data-k-quiz-restart]').addEventListener('click', function () { picks = []; render(); });
      render();
    });
  }

  /* ---- Option picker for a product form: [data-k-picker] containing
         <script type="application/json" data-k-variants> [{id, options:[..], available, image}] </script>
         option groups [data-k-option-index="0"] with buttons [data-value]
         hidden input[name="id"], optional [data-k-image] <img>, [data-k-summary], [data-k-submit]
         [data-k-own-size] wrapper shown when the size option value matches data-own-value ---- */
  function picker(root) {
    $$('[data-k-picker]', root).forEach(function (wrap) {
      if (wrap.__k) return; wrap.__k = true;
      var vEl = wrap.querySelector('[data-k-variants]');
      if (!vEl) return;
      var variants; try { variants = JSON.parse(vEl.textContent); } catch (e) { return; }
      var groups = $$('[data-k-option-index]', wrap);
      var selected = groups.map(function (g) {
        var on = g.querySelector('[aria-pressed="true"]') || g.querySelector('[data-value]');
        return on ? on.getAttribute('data-value') : null;
      });
      var idInput = wrap.querySelector('input[name="id"]');
      var img = wrap.querySelector('[data-k-image]');
      var summary = wrap.querySelector('[data-k-summary]');
      var submit = wrap.querySelector('[data-k-submit]');
      var own = wrap.querySelector('[data-k-own-size]');
      var ownField = own ? own.querySelector('textarea, input') : null;
      var hintFor = {}; try { hintFor = own ? JSON.parse(own.getAttribute('data-hints') || '{}') : {}; } catch (e) { hintFor = {}; }

      var update = function () {
        groups.forEach(function (g, gi) {
          $$('[data-value]', g).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-value') === selected[gi] ? 'true' : 'false'); });
        });
        var match = variants.filter(function (v) { return v.options.every(function (o, i) { return selected[i] == null || o === selected[i]; }); })[0];
        if (idInput && match) idInput.value = match.id;
        if (submit) {
          var ok = !!(match && match.available);
          submit.disabled = !ok;
          submit.textContent = ok ? submit.getAttribute('data-label') : submit.getAttribute('data-label-off');
        }
        if (img && match && match.image) { img.src = match.image; img.alt = selected.join(' · '); }
        if (own) {
          var ownValue = own.getAttribute('data-own-value');
          var isOwn = selected.indexOf(ownValue) !== -1;
          own.hidden = !isOwn;
          if (ownField) {
            ownField.required = isOwn;
            ownField.disabled = !isOwn;
            var hint = hintFor[selected[0]] || hintFor['*'];
            if (hint) ownField.placeholder = hint;
          }
        }
        if (summary) {
          var parts = selected.slice();
          summary.textContent = parts.join(' · ');
        }
        $$('[data-k-show-for]', wrap).forEach(function (el) {
          el.hidden = selected.indexOf(el.getAttribute('data-k-show-for')) === -1;
        });
      };
      groups.forEach(function (g, gi) {
        $$('[data-value]', g).forEach(function (b) {
          b.addEventListener('click', function () { selected[gi] = b.getAttribute('data-value'); update(); });
        });
      });
      update();
    });
  }

  /* ---- Units switch: [data-k-units][data-unit="in|cm"] with buttons [data-k-unit-btn],
         cells [data-k-len][data-in][data-src][data-src-unit], labels [data-k-unit-label] ---- */
  function units(root) {
    $$('[data-k-units]', root).forEach(function (wrap) {
      if (wrap.__ku) return; wrap.__ku = true;
      var unit = wrap.getAttribute('data-unit') || 'in';
      try { var saved = window.localStorage.getItem('kiat-unit'); if (saved === 'in' || saved === 'cm') unit = saved; } catch (e) {}
      var fmt = function (n) { var r = Math.round(n * 2) / 2; return r % 1 === 0 ? r.toFixed(0) : r.toFixed(1); };
      var apply = function () {
        $$('[data-k-unit-btn]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-k-unit-btn') === unit ? 'true' : 'false'); });
        $$('[data-k-unit-label]', wrap).forEach(function (l) { l.textContent = '(' + unit + ')'; });
        $$('[data-k-len]', wrap).forEach(function (c) {
          if (c.getAttribute('data-src-unit') === unit) { c.textContent = c.getAttribute('data-src'); return; }
          var inches = parseFloat(c.getAttribute('data-in'));
          if (!isNaN(inches)) c.textContent = fmt(unit === 'cm' ? inches * 2.54 : inches);
        });
      };
      $$('[data-k-unit-btn]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          unit = b.getAttribute('data-k-unit-btn');
          try { window.localStorage.setItem('kiat-unit', unit); } catch (e) {}
          apply();
        });
      });
      apply();
    });
  }

  /* ---- Horizontal photo strip: [data-k-strip] with [data-k-strip-track] and buttons [data-k-strip-step="-1|1"] ---- */
  function strip(root) {
    $$('[data-k-strip]', root).forEach(function (wrap) {
      if (wrap.__kst) return; wrap.__kst = true;
      var track = wrap.querySelector('[data-k-strip-track]');
      if (!track) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      $$('[data-k-strip-step]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = parseInt(b.getAttribute('data-k-strip-step'), 10) || 1;
          track.scrollBy({ left: dir * Math.max(240, track.clientWidth * 0.8), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---- Phone menu: button[data-k-menu][aria-controls] opens the header links ---- */
  function menu(root) {
    $$('[data-k-menu]', root).forEach(function (btn) {
      if (btn.__kmn) return; btn.__kmn = true;
      var header = btn.closest('.k-header');
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      var set = function (open) {
        if (header) header.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? (btn.getAttribute('data-close') || 'Close') : (btn.getAttribute('data-open') || 'Menu');
      };
      btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { set(false); btn.focus(); }
      });
      if (nav) nav.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a')) set(false); });
    });
  }

  /* ---- Bag panel: [data-kbag] <dialog> (sections/kiat-bag-drawer). "Add to bag" and Remove stay on the
         page; the panel's [data-kbag-body] is re-rendered by the Section Rendering API. Any failure
         falls back to the plain form post, so the bag page still works without this. ---- */
  function bag() {
    var dlg = document.querySelector('[data-kbag]');
    if (!dlg || dlg.__k) return; dlg.__k = true;
    var section = dlg.getAttribute('data-kbag-section');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    var render = function (html, error) {
      if (html) {
        var body = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-kbag-body]');
        if (body) {
          dlg.querySelector('[data-kbag-body]').replaceWith(body);
          $$('[data-k-bag-count]').forEach(function (c) { c.textContent = body.getAttribute('data-count'); });
        }
      }
      var err = dlg.querySelector('[data-kbag-error]');
      if (err) { err.textContent = error || ''; err.hidden = !error; }
    };
    var open = function () {
      dlg.classList.remove('is-closing');
      if (!dlg.open) dlg.showModal();
    };
    var close = function () {
      if (!dlg.open || dlg.classList.contains('is-closing')) return;
      if (still) { dlg.close(); return; }
      dlg.classList.add('is-closing');
      var done = function (e) {
        if (e.target !== dlg) return;
        dlg.removeEventListener('animationend', done);
        dlg.classList.remove('is-closing');
        dlg.close();
      };
      dlg.addEventListener('animationend', done);
    };
    var post = function (url, body) {
      return fetch(root + url, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
    };

    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-kbag-close]')) { close(); return; }
      var rm = e.target.closest('[data-kbag-remove]');
      if (!rm) return;
      e.preventDefault();
      var fd = new FormData();
      fd.append('line', rm.getAttribute('data-kbag-remove'));
      fd.append('quantity', '0');
      fd.append('sections', section);
      post('cart/change.js', fd).then(function (res) { render(res.j.sections && res.j.sections[section]); })
        .catch(function () { location.href = rm.href; });
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-k-bag-open]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      open();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (e.defaultPrevented || !form.matches('form[action*="/cart/add"]') || !window.fetch) return;
      e.preventDefault();
      var btns = $$('[type="submit"]', form).concat(form.id ? $$('[type="submit"][form="' + form.id + '"]') : []);
      btns.forEach(function (b) { b.__kWas = b.disabled; b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      var fd = new FormData(form);
      fd.append('sections', section);
      post('cart/add.js', fd)
        .then(function (res) {
          if (res.ok) { render(res.j.sections && res.j.sections[section]); open(); return; }
          /* e.g. the piece closed a moment ago: show the bag as it is, with the reason */
          return fetch(root + '?sections=' + section).then(function (r) { return r.json(); })
            .then(function (j) { render(j[section], res.j.description || res.j.message); open(); });
        })
        .catch(function () { HTMLFormElement.prototype.submit.call(form); })
        .then(function () { btns.forEach(function (b) { b.disabled = b.__kWas; b.removeAttribute('aria-busy'); }); });
    });
  }

  function init(root) { accordion(root); lang(root); archive(root); countdown(root); countdownStage(root); buyBar(root); quiz(root); picker(root); units(root); strip(root); menu(root); }

  document.addEventListener('DOMContentLoaded', function () { clock(); bag(); init(document); });
  /* theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
